import styled from 'styled-components';

import { spaceMixin } from '@zillow/constellation';

import { StyledContentContainer } from '../StyledComponents/StyledLayout';

export const StyledExtendedContentContainer = styled(StyledContentContainer)`
  padding-bottom: 0;
  margin-bottom: -${spaceMixin('lg')};
`;
